export default __webpack_public_path__ + "static/media/vozik_logo.ac6c21f2.png";